<script setup lang="ts">
withDefaults(defineProps<{
  debug?: boolean
}>(), {
  debug: false,
})
</script>

<template>
  <Frame class="m-frame frame-details-contact" :class="{ debug }" w="
  grid grid-cols-[1fr] g-2 d:g-0 t:grid-cols-[100px_1fr] mw-96 mx-auto
">

  <Frame class="col-icon" w="col-clamp">
    <slot name="icon">
      
    </slot>
  </Frame>
  <Frame class="col-statement" w="w-full mx-auto max-w-92% txs:max-w-92% t:w-full t:max-w-700px tm:max-w-92% d:max-w-85%">
    <slot name="content">
      
    </slot>
  </Frame>

  </Frame>
</template>

<style lang="scss" scoped>
.m-frame {
  &.frame-details-contact {

    .col-details {}

    .col-contact {}

  }

  &.debug {
    box-shadow: inset 0 0 0 1px red;

    :deep(>.m-wrap) {
      box-shadow: inset 0 0 0 1px blue;

      .col-details {
        box-shadow: inset 0 0 0 1px green;

        >.m-wrap {
          box-shadow: inset 0 0 0 1px pink;
        }
      }

      .col-contact {
        box-shadow: inset 0 0 0 1px orange;

        >.m-wrap {
          box-shadow: inset 0 0 0 1px purple;
        }
      }
    }
  }
}
</style>